export default {
  attachConfiguration: 'add-configuration',
  calculationWindow: 'calculation-window',
  offerProduct: 'offer-product',
};
